module.exports = __webpack_public_path__ + "img/99icon_black.a29c3a26.svg";